import React from "react";
import { useGetCollectPaymentContext } from "../context";
import MessageItem from "./StripMessageItem";

const TopStripAlert = () => {
  const { topStrip, setTopStrip } = useGetCollectPaymentContext();
  const { mgsList } = topStrip;
  const deleteHandler = (index) => {
    setTopStrip((prev) => ({
      ...prev,
      mgsList: prev.mgsList.filter((_, i) => i !== index),
    }));
  };
  if (!topStrip.isShow) return "";

  return mgsList.map((item, index) => (
    <MessageItem
      key={index}
      item={item}
      onDelete={() => deleteHandler(index)}
    />
  ));
};

export default TopStripAlert;
